import { MODE_PREVIEW } from '../config/constants';



const searchParams = new URLSearchParams(window.location.search);
const isPreviewMode = searchParams.get('mode') === MODE_PREVIEW;

if (isPreviewMode) {
  window.document.body.classList.add('hide-scrollbar', 'preview');
}




// WEBPACK FOOTER //
// ./src/lib/preview.js